import React from 'react';
import { observer } from 'mobx-react';

import Tag from 'core/components/Tag';

import { getOption } from '../../form/components/modalSelect/selectHelpers';

const SelectValuesRenderer = (props) => {
  const { onUnselectBuilder, options, tagFill, valueRenderer, valueTagProps, values, responsive } = props;

  if (!options) {
    return null;
  }

  // when responsive, tags must shrink and truncate so they never wrap to a new line.
  // Merge valueTagProps first so responsive overrides take final precedence.
  const mergedTagProps = responsive
    ? {
        ...valueTagProps,
        style: { ...(valueTagProps?.style ?? {}), minWidth: 24, flexShrink: 1, overflow: 'hidden' },
        ellipsis: true
      }
    : valueTagProps;

  return values.map((val) => {
    const valueOption = getOption(options, val);

    if (!valueOption) {
      return null;
    }

    const onRemove = onUnselectBuilder(valueOption.value || valueOption);

    return (
      <Tag
        key={valueOption.key || val}
        minimal
        fill={tagFill}
        onRemove={onRemove}
        round
        bg={valueOption.bg}
        color={valueOption.color}
        {...mergedTagProps}
      >
        {valueRenderer(valueOption)}
      </Tag>
    );
  });
};

export default observer(SelectValuesRenderer);
